import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import Title from "./Title";
import getImageAssetURL from "utils/images/getImageAssetURL";
import { ProposalFile, JobPhaseFile } from "generated/graphql";
import JobPhaseFiles from "modules/JobPhases/JobPhaseFiles";
import AddFiles from "modules/JobPhases/AddFiles";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { Edit } from "@mui/icons-material";
import { useState } from "react";
import isImage from "utils/images/isImage";
import Lightbox from "yet-another-react-lightbox";

export default function JobImages({ jobImages }: { jobImages: JobPhaseFile[] }) {
  const [editMode, setEditMode] = useState(false);
  const [index, setIndex] = useState(-1);
  const slides = jobImages
    .map((jobPhaseFile) => {
      if (isImage(jobPhaseFile.filename)) {
        return {
          src: `${import.meta.env.VITE_CDN_BASE_URL}/${jobPhaseFile.filename}`,
        };
      }

      return null;
    })
    .filter(Boolean);
  return (
    <MDBox
      mb={2}
      className="no-break"
      sx={{
        "@media print": {
          display: !slides.length ? "none" : undefined,
        },
      }}
    >
      <Card sx={{ overflow: "hidden" }}>
        <MDBox
          bgColor="#f5f5f5"
          py={1.5}
          px={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            color: "#344767",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit",
          }}
        >
          <MDTypography variant="h4" sx={{ fontSize: "1rem", lineHeight: 1.2, color: "#344767" }}>
            Job Images
          </MDTypography>
          <MDButton
            type="button"
            variant="text"
            color="info"
            sx={{ maxHeight: "25px", minHeight: 0, p: 0 }}
            className="no-print"
            onClick={() => setEditMode(!editMode)}
          >
            <Edit />
          </MDButton>
        </MDBox>
        <MDBox p={4}>
          <Grid container spacing={3} alignItems="center">
            {editMode && (
              <Grid item xs={12}>
                <JobPhaseFiles />
                <MDBox
                  sx={{
                    width: "23vw",
                    position: "relative",
                    "& .uppy-DragDrop-inner": { padding: "16px 0" },
                    "& .uppy-DragDrop-label": { fontSize: "1em" },
                  }}
                >
                  <AddFiles />
                </MDBox>
              </Grid>
            )}
            {!editMode && (
              <>
                <Lightbox
                  open={index >= 0}
                  index={index}
                  close={() => setIndex(-1)}
                  slides={slides}
                />
                <Grid
                  container
                  spacing={2}
                  sx={{
                    alignItems: "flex-start",
                    "@media print": {
                      display: "block",
                    },
                  }}
                >
                  {jobImages?.map((image, index) => (
                    <Grid
                      item
                      key={image.id}
                      xs="auto"
                      sx={{
                        cursor: "pointer",
                        "@media print": {
                          display: "inline-block",
                          width: "48%",
                          margin: "0 1% 12px",
                          verticalAlign: "top",
                          boxSizing: "border-box",
                          pageBreakInside: "avoid",
                        },
                      }}
                    >
                      <MDBox
                        component="img"
                        src={getImageAssetURL(image.filename)}
                        alt={image.filename}
                        onClick={() => setIndex(index)}
                        sx={{
                          width: 112,
                          height: 112,
                          objectFit: "cover",
                          borderRadius: "10px",
                          border: "1px solid rgba(0, 0, 0, 0.12)",
                          display: "block",
                          backgroundColor: "#fff",
                          "@media print": {
                            width: "100%",
                            height: "auto",
                            objectFit: "contain",
                            borderRadius: 0,
                            border: "1px solid rgba(0, 0, 0, 0.08)",
                          },
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </>
            )}
          </Grid>
        </MDBox>
      </Card>
    </MDBox>
  );
}
